import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { connect } from "react-redux";
import { ClipLoader } from "react-spinners";
import { useHotkeys } from "react-hotkeys-hook";
import {
  Card,
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Grid,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography,
  CircularProgress,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";
import { styles } from "../theme/styles";
import { styled } from "@mui/material/styles";
import { Creators as StoresCreators } from "../store/ducks/stores";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TablePagination from "@mui/material/TablePagination";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import LinearWithValueLabel from "./LinearLabel";
import { parse } from "papaparse";
import Cookies from "js-cookie";
import { verifyToken } from "../helpers/jwtValidation";
import axios from "axios";

const TableForm2 = (props) => {
  const {
    stores,
    token,
    storeId,
    updateStockStores,
    downloadInventoryByStore,
    loadingStores,
    loading,
    updateStoreById,
    userData,
  } = props;
  const [initialRows, setInitialRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [modifiedStock, setModifiedStock] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [error, setError] = useState(false);
  const inputFileRef = useRef(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const columnWidth = 100 / 7;
  const [rolEnCookie, setRolEnCookie] = useState();
  const [isButtonEnabledAux, setIsButtonEnabledAux] = useState();
  const [tiendasDisp, setTiendasDisp] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [storeData, setStoreData] = useState([]);
  const [mostrarSpinner, setMostrarSpiner] = useState(false);
  useEffect(() => {
    setMostrarSpiner(loading)
  }, [loading])
  

  const fetchStoreData = async (storeId) => {
    try {
      setMostrarSpiner(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_PETCOZOO}/stores/getStoreById/${storeId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      const data = await response.json();

      const mappedData = data.actualInventory.map((item) =>
        createData(
          item.subCategoryName,
          item.description,
          item.subCategoryId,
          item.material,
          item.stock,
          item.price
        )
      );

      setInitialRows(mappedData); // Para backup o edición posterior
      setStoreData(mappedData); // El array que usas en el render
      setPage(0); // Reinicia paginación al cambiar tienda
    } catch (error) {
      console.error("Error al obtener datos de tienda:", error);
    } finally {
      setMostrarSpiner(false);
    }
  };

  const getAllTiendas = async () => {
    try {
      const info = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/users/getAllUsers`
      );
      const { data } = info;
      console.log("data obtenida:", data);

      const tiendas = data.filter((registro) => registro.rol === "STORE");
      console.log("tiendas:", tiendas);
      setTiendasDisp(tiendas);
      // Aquí puedes hacer lo que necesites con 'tiendas'
    } catch (error) {
      console.log("ocurrió un error en getAllTiendas:", error);
    }
  };
  useEffect(() => {
    const loginCookie = Cookies.get("loginCookie");
    const userData = verifyToken(loginCookie).data.data;
    // console.log("cookievalor: ", userData);
    setRolEnCookie(userData);
  }, []);
  useEffect(() => {
    if (Cookies.get("loginCookie")) {
      const loginCookie = Cookies.get("loginCookie");
      const userData = verifyToken(loginCookie).data.data;
      // console.log("cookievalor: ", userData);
      setRolEnCookie(userData);
      if (userData.rol == "STORE") {
        const isMonday = new Date().getDay() === 1;
        const currentHour = new Date().getHours();
        const isInTimeRange = currentHour >= 8 && currentHour < 22;
        const isButtonEnabled = isMonday && isInTimeRange;
        setIsButtonEnabledAux(isButtonEnabled);
      } else if (userData.rol == "ADMIN") {
        getAllTiendas();
      }
    }
  }, []);
  useEffect(() => {
    if (stores && Array.isArray(stores) && stores.length > 0) {
      const storeWithIdNumber = stores[0];

      if (
        storeWithIdNumber &&
        Array.isArray(storeWithIdNumber.actualInventory)
      ) {
        setInitialRows(
          storeWithIdNumber.actualInventory.map((item) =>
            createData(
              item.subCategoryName,
              item.description,
              item.subCategoryId,
              item.material,
              item.stock,
              parseFloat(item.price).toFixed(2)
            )
          )
        );
      } else {
      }
    } else {
    }
  }, [stores]);

  useEffect(() => {
    const filtered = initialRows.filter((row) => {
      const {
        subCategoryName,
        description,
        subCategory,
        material,
        stock,
        price,
      } = row;
      const searchValue = searchTerm.toLowerCase();

      return (
        String(subCategoryName.toLowerCase()).includes(searchValue) ||
        String(description.toLowerCase()).includes(searchValue) ||
        String(subCategory).includes(searchValue) ||
        String(material).includes(searchValue) ||
        String(stock).includes(searchValue)
        // ||
        // String(price).includes(searchValue)
      );
    });

    setFilteredRows(filtered);
    setPage(0);
  }, [initialRows, searchTerm]);

  const createData = useMemo(
    () =>
      (subCategoryName, description, subCategory, material, stock, price) => {
        return {
          subCategoryName,
          description,
          subCategory,
          material,
          stock,
          price: parseFloat(price).toFixed(2),
        };
      },
    []
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const rowsToDisplay = filteredRows.slice(startIndex, endIndex);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#00205b",
      color: theme.palette.common.white,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#dcffed",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleSearch = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const handleStockInputChange = (event) => {
    const inputValue = event.target.value;
    if (/^$|^\d+$/.test(inputValue)) {
      setModifiedStock(inputValue);
      setError(false);
    }
  };

  const blockEditByRol = () => {
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();

    if (
      currentDay !== 1 ||
      currentHour > 23 ||
      (currentHour === 23 && currentMinute >= 59)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleStockEdit = (index) => {
    const selectedProduct = rowsToDisplay[index];
    //console.log("selectedProdcut", selectedProduct);
    setSelectedProduct(selectedProduct);
    setModifiedStock(rowsToDisplay[index].stock);
    setSelectedRowIndex(index);
    setOpenDialog(true);
  };

  const handdleOnCloseModal = () => {
    setOpenDialog(false);
    setSelectedRowIndex(null);
    setModifiedStock("");
    setError(false);
  };

  const handleStockSave = async () => {
    if (modifiedStock == null || modifiedStock === "") {
      setError(true);
      return;
    }
    const newStock = { ...selectedProduct, stock: modifiedStock };
    await updateStockStores(token, storeId, newStock);
    setOpenDialog(false);
    setSelectedRowIndex(null);
    setModifiedStock("");
    setError(false);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useHotkeys("up,down", (event, handler) => {
    if (openDialog) {
      if (event.key === "ArrowDown") {
        if (
          selectedRowIndex === rowsToDisplay.length - 1 &&
          page !== filteredRows / page
        ) {
          setPage(page + 1);
          setSelectedRowIndex(0);
        } else {
          setSelectedRowIndex((prevIndex) =>
            prevIndex === null
              ? 0
              : Math.min(prevIndex + 1, rowsToDisplay.length - 1)
          );
        }
      } else if (event.key === "ArrowUp") {
        if (selectedRowIndex === 0 && page !== 0) {
          setPage(page - 1);
          setSelectedRowIndex(rowsToDisplay.length - 1);
          //console.log(rowsToDisplay);
        } else {
          setSelectedRowIndex((prevIndex) =>
            prevIndex === null ? 0 : Math.max(prevIndex - 1, 0)
          );
        }
      }

      if (selectedRowIndex !== null) {
        setModifiedStock(rowsToDisplay[selectedRowIndex].stock);
      }
    }
  });

  const handleStores = (event) => {
    event.preventDefault();

    if (stores && token) {
      downloadInventoryByStore(token, storeId);
    } else {
      console.error("Error ");
    }
  };

  const handleFileChange = async (event) => {
    try {
      const file = event.target.files[0];
      //console.log(file);

      if (file) {
        parse(file, {
          header: true,
          complete: (result) => {
            updateStoreById(token, storeId, result.data);
            inputFileRef.current.value = null;
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
            inputFileRef.current.value = null;
          },
        });
      }
    } catch (error) {
      console.error("Error in handleFileChange:", error);
    }
  };

  return (
    <div style={{ height: "90%", width: "90%", paddingTop: "10px" }}>
      <div height={"10%"} className="actions">
        <div style={{ width: "220px" }} className="pz-center">
          <TextField
            placeholder="Buscar"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearch}
            fullWidth
            InputLabelProps={{ shrink: false }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-filter-search"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="gray"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M11.36 20.213l-2.36 .787v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414" />
                    <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                    <path d="M20.2 20.2l1.8 1.8" />
                  </svg>
                </InputAdornment>
              ),
            }}
          />
        </div>

        {/* <div className="pz-center">
          {loadingStores && <LinearWithValueLabel loading={loadingStores} />}
        </div> */}
      </div>

      {rolEnCookie && rolEnCookie.rol === "ADMIN" && (
        <>
          <label htmlFor="tiendaSelect">Selecciona una tienda:</label>
          <select
            id="tiendaSelect"
            name="tienda"
            value={selectedStoreId}
            onChange={(e) => {
              const selectedId = e.target.value;
              console.log("selectedId: ", e.target.value);
              setSelectedStoreId(selectedId);
              if (selectedId) {
                fetchStoreData(selectedId);
              }
            }}>
            <option value="">-- Elige una tienda --</option>
            {tiendasDisp.map((tienda) => (
              <option key={tienda._id} value={tienda.idNumber}>
                {tienda.name} ({tienda.sucursalAsignada})
              </option>
            ))}
          </select>
        </>
      )}

      {mostrarSpinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}>
          <ClipLoader color="#00205B" loading={true} size={60} />
        </div>
      )}
      <TableContainer
        sx={{
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ABABAB",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#888",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
          },
          "& .MuiTableCell-root": {
            fontSize: {
              xs: "8px",
              sm: "12px",
              md: "14px",
            },
          },
        }}
        style={styles.containerTable2}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">SUBCATEGORÍA</StyledTableCell>
              <StyledTableCell align="center">DESCRIPCIÓN</StyledTableCell>
              <StyledTableCell align="center">ID SUBCATEGORÍA</StyledTableCell>
              <StyledTableCell align="center">MATERIAL</StyledTableCell>
              <StyledTableCell align="center">STOCK</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rowsToDisplay.map((row, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell align="center">
                  {row.subCategoryName}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.description}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.subCategoryId || row.subCategory}
                </StyledTableCell>
                <StyledTableCell align="center">{row.material}</StyledTableCell>
                <StyledTableCell align="center">{row.stock}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Card>
        <TablePagination
          component="div"
          sx={{ display: "flex", justifyContent: "flex-start" }}
          count={filteredRows.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Productos por página:"
          rowsPerPageOptions={[10, 20, 50]}
        />
      </Card>

      <Dialog open={openDialog} onClose={handdleOnCloseModal}>
        <DialogTitle align="center" style={{ fontWeight: "bold" }}>
          Editar Stock
        </DialogTitle>
        <DialogContent>
          {rowsToDisplay[selectedRowIndex] !== undefined ? (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  SUBCATEGORÍA:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].subCategoryName}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  DESCRIPCIÓN:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].description}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  ID SUBCATEGORÍA:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].subCategoryId ||
                    rowsToDisplay[selectedRowIndex].subCategory}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  MATERIAL:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  {rowsToDisplay[selectedRowIndex].material}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontWeight: "bold" }}
                  variant="subtitle1"
                  gutterBottom>
                  STOCK:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Stock"
                  variant="outlined"
                  required
                  value={modifiedStock}
                  error={error}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleStockInputChange}
                  size="small"
                />
              </Grid>
            </Grid>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handdleOnCloseModal()}
            color="secondary"
            startIcon={<CloseIcon />}>
            Cancelar
          </Button>
          <Button
            onClick={handleStockSave}
            color="primary"
            startIcon={<SaveIcon />}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stores: state.stores.stores,
    loading: state.stores.loading,
    token: state.users.uid,
    storeId: state.users.idNumber,
    loadingStores: state.stores.loading,
  };
};

const mapDispatchToProps = {
  updateStockStores: StoresCreators.updateStockStores,
  updateStoreById: StoresCreators.updateStoreById,
  downloadInventoryByStore: StoresCreators.downloadInventoryByStore,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableForm2);
